export const FETCH_SUPPLIERS = 'FETCH_SUPPLIERS';
export const PUSH_SUPPLIERS = 'PUSH_SUPPLIERS';
export const REMOVE_SUPPLIERS = 'REMOVE_SUPPLIERS';
export const UPDATE_SUPPLIERS = 'UPDATE_SUPPLIERS';
export const UPDATE_MODE = 'UPDATE_MODE';
export const UPDATE_ACTIVE_ID = 'UPDATE_ACTIVE_ID';

export function fetchSuppliers(data){
  return (dispatch) => {
    dispatch({
      type: FETCH_SUPPLIERS,
      payload:data
    });
  }
}

export function pushSuppliers(data){
  return (dispatch) => {
    dispatch({
      type: PUSH_SUPPLIERS,
      payload:data
    });
  }
}

export function removeSuppliers(data){
  return (dispatch) => {
    dispatch({
      type: REMOVE_SUPPLIERS,
      payload:data
    });
  }
}

export function updateSuppliers(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_SUPPLIERS,
      payload:data
    });
  }
}

export function updateMode(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_MODE,
      payload:data
    });
  }
}

export function updateActiveSuppliers(mode, id){
  return (dispatch) => {
    dispatch({
      type: UPDATE_ACTIVE_ID,
      mode,
      id
    });
  }
}
